import request from "../utils/request"

export const getModules = courseId => request.get(`/courses/${courseId}/modules`)

export const getModule = moduleId => request.get(`/modules/${moduleId}`)
